module.exports = __webpack_public_path__ + "static/img/4992_phase_function_Paper_Points.f6fd444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4992_phase_function_Paper_Points.png
// module id = WbxR
// module chunks = 0